export const MARK_PANEL_WIDTH_CLASS = 'w-96';

export const MARK_PANEL_Z_INDEX_CLASS = 'z-[60]';

export const MARK_PANEL_TITLE = 'Ask MARK';

export const MARK_PROMPTS_LABEL = 'Start with...';

export const MARK_PANEL_CLOSE_ARIA_LABEL = 'Close Ask MARK';

export const MARK_FLOATING_BUTTON_HINT_ID = 'mark-floating-button';
